import { Link, useLocation } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { LOGO_URL } from "@/lib/api";

const links = [
  { to: "/", label: "Studio" },
  { to: "/shop", label: "Shop" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/quote", label: "Custom Work" },
  { to: "/business", label: "Business" },
  { to: "/gift-cards", label: "Gift Cards" },
];

const Navbar = () => {
  const { count, setOpen } = useCart();
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 w-full z-50 backdrop-blur-2xl bg-black/60 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Ember & Steel Studio" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block leading-tight">
            <span className="font-serif-display text-lg tracking-wide">
              <span className="text-[#C87455]">Ember</span>
              <span className="text-zinc-500 mx-1">&amp;</span>
              <span className="text-[#A9B0B7]">Steel</span>
            </span>
            <span className="block font-mono-tech text-[9px] uppercase tracking-[0.35em] text-zinc-500">Studio</span>
          </div>
        </Link>

        <nav className="flex items-center gap-8">
          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                className={`link-line font-mono-tech text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${
                  pathname === l.to || (l.to !== "/" && pathname.startsWith(l.to)) ? "text-[#C87455]" : "text-zinc-400 hover:text-white"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>
          <button
            data-testid="cart-open-btn"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 text-zinc-300 hover:text-[#C87455] transition-colors duration-300"
            aria-label="Open cart"
          >
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-2 h-4 min-w-4 px-1 bg-[#C87455] text-black text-[10px] font-mono-tech flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>
        </nav>
      </div>
      <div className="md:hidden border-t border-white/5 flex flex-wrap justify-center gap-x-5 gap-y-1 py-2 px-3">
        {links.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className={`font-mono-tech text-[10px] uppercase tracking-[0.2em] ${
              pathname === l.to || (l.to !== "/" && pathname.startsWith(l.to)) ? "text-[#C87455]" : "text-zinc-400"
            }`}
            data-testid={`nav-mobile-${l.label.toLowerCase().replace(" ", "-")}`}
          >
            {l.label}
          </Link>
        ))}
      </div>
    </header>
  );
};

export default Navbar;
